module.exports = "<!-- <app-sidebar></app-sidebar> -->\r\n<app-navbar class=\"navbarShow\"></app-navbar>\r\n\r\n<div class=\"app-body\">\r\n    \r\n    <app-sidebar id=\"sidebarclass\"></app-sidebar>\r\n    <div class=\"main-content\">\r\n        <div class=\"content-wrapper\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n    <app-footer></app-footer>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/2-columns-layout/2-columns-layout.component.html
// module id = ./src/app/layouts/2-columns-layout/2-columns-layout.component.html
// module chunks = main